import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  className?: string;
  href?: string;
  onClick?: () => void;
}
export function CTAButton({
  text = 'Quiero mi copia ahora',
  className = '',
  href = '#precio',
  onClick
}: CTAButtonProps) {
  return <a href={href} onClick={onClick} className={`
        group relative inline-flex flex-col items-center justify-center
        bg-[#C9A84C] hover:bg-[#b5953e] text-[#2D2D2D] 
        px-8 py-5 rounded-2xl font-bold
        shadow-[0_8px_30px_rgb(201,168,76,0.3)] hover:shadow-[0_8px_30px_rgb(201,168,76,0.5)]
        transition-all duration-300 hover:-translate-y-1
        no-underline cursor-pointer
        ${className}
      `} data-id="element-1">
      <span className="inline-flex items-center gap-2 mb-1" data-id="element-2">
        <span className="bg-green-600 text-white text-xs md:text-sm font-extrabold tracking-wide uppercase px-3 py-1 rounded-full shadow-sm animate-pulse" data-id="element-3">
          🔥 68% OFF
        </span>
        <span className="text-xs md:text-sm font-semibold tracking-wide uppercase text-[#1B5E5E]" data-id="element-4">
          Oferta de Hoy
        </span>
      </span>
      <span className="flex items-center gap-3 text-xl md:text-2xl mt-1" data-id="element-5">
        {text}
        <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-6" />
      </span>
      <span className="text-lg md:text-xl font-extrabold mt-1 flex items-center gap-2" data-id="element-7">
        <span className="line-through opacity-50 text-base text-gray-500" data-id="element-8">
          $19.99
        </span>
        <span className="text-green-600 text-2xl md:text-3xl" data-id="element-9">$6.39</span>
      </span>
    </a>;
}